import { render, staticRenderFns } from "./NoTool.vue?vue&type=template&id=a49828e4&"
import script from "./NoTool.vue?vue&type=script&lang=js&"
export * from "./NoTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports